import { IconProps } from "./types";

export default function IcoRentedVehicle(props: Readonly<IconProps>): JSX.Element {
	const { color = "#1D1D1D", size = "24" } = props;
	return (
		<svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M11.6369 10.669H6.39315V13.169C9.13665 13.169 9.28105 17.6337 6.39315 17.6337V19.9984H11.6369M11.6369 10.669H20V13.169C17.4009 13.169 17.2565 17.6337 20 17.6337V19.9984H11.6369M11.6369 10.669V13.0337M11.6369 19.9984V17.6337M11.6369 14.6959V15.928M4 7.33504V13.0678C4 13.7901 4.58876 14.3757 5.31503 14.3757H8.27738M4 7.33504V5.30785C4 4.58555 4.58876 4 5.31503 4H15.8352C16.5615 4 17.1502 4.58555 17.1502 5.30785V7.33504M4 7.33504H17.1502M17.1502 7.33504V10.669M15.1061 17.3209C15.5657 17.3209 15.9105 16.9781 15.9105 16.5209C15.9105 16.0638 15.5932 15.9632 15.1061 15.721C14.6189 15.4787 14.3017 15.3781 14.3017 14.921C14.3017 14.4639 14.6465 14.121 15.1061 14.121M15.1061 17.3209V17.7209M15.1061 17.3209C14.8386 17.3209 14.6101 17.2048 14.4657 17.0177M15.1061 14.121V13.721M15.1061 14.121C15.3673 14.121 15.5914 14.2318 15.7362 14.4113"
				stroke={color}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
